/**
 * Default Configuration for the Google Static Map
 */
export class StaticMapConfig {
	public zoom?: number;
	public homeIcon?: string;
	public scale?: number;
	public size?: string;
	public type?: string;

	constructor() {
		this.zoom = 16;
		this.homeIcon = 'https://invision-plus.classvaluation.com/assets/img/marker/marker-user-location-l.png';
		this.scale = 2;
		this.size = '640x640';
		this.type = 'satellite';
	}
}

export class StaticMapRequest {
	public location: StaticLocation;
	public address?: string; // Center as an Address
	public markers: StaticMarker[];
}

export class StaticMarker {
	public icon?: string; // Color or Icon, not both
	public color?: string;
	public location: StaticLocation;
}

export class StaticLocation {
	public lat: number;
	public lng: number;
}